import { Button, Text } from '@mercai/clever'

import styles from './empty-state.module.css'

import type { EmptyStateProps } from './empty-state.type'
import {
  getCoreClasses,
  getImageClasses,
  getSubTitleClasses,
  getTitleClasses,
} from './empty-state.constants'

export const EmptyState = ({
  className,
  description,
  title,
  onClickButton,
  buttonText,
  horizontal = false,
}: EmptyStateProps) => {
  return (
    <div className={getCoreClasses(horizontal, className)}>
      <img
        alt="Empty state"
        src="/images/empty-state.svg"
        className={getImageClasses(horizontal)}
      />

      <div className={styles.content}>
        <Text variant="title-medium" className={getTitleClasses(horizontal)}>
          {title}
        </Text>
        <Text className={getSubTitleClasses(horizontal)}>{description}</Text>
      </div>

      {onClickButton && (
        <Button variant="primary" onClick={onClickButton}>
          {buttonText}
        </Button>
      )}
    </div>
  )
}
